// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a4e4a77b","769":"d1ca6817"}[chunkId] + ".chunk.js";
};